// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { KindClassification, TagKindClassification } from "../schema";
import { serialize_KindClassification_internal, deserialize_KindClassification_internal } from "./KindClassification";

export function serialize_TagKindClassification_internal(value: TagKindClassification): unknown {
  return ((value: { discriminator: KindClassification; id: bigint; kind: KindClassification }): unknown => {
    return {
      discriminator: ((value: KindClassification): unknown => {
        return serialize_KindClassification_internal(value);
      })(value["discriminator"]),
      id: ((value: bigint): unknown => {
        return value;
      })(value["id"]),
      kind: ((value: KindClassification): unknown => {
        return serialize_KindClassification_internal(value);
      })(value["kind"]),
    };
  })(value);
}
export function serialize_TagKindClassification(obj: TagKindClassification): string {
  return renderJsonWithNumbersAsBigint(serialize_TagKindClassification_internal(obj));
}
export function deserialize_TagKindClassification_internal(value: unknown): ParserResult<TagKindClassification> {
  return ((
    value: unknown,
  ): ParserResult<{
    discriminator: KindClassification;
    id: bigint;
    kind: KindClassification;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/TagKindClassification]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/TagKindClassification]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "discriminator")) {
      return { success: false, reason: `[#/components/schemas/TagKindClassification/discriminator]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'discriminator'.` };
    }
    const parsed_discriminator = ((): ParserResult<KindClassification> => {
      return ((value: unknown): ParserResult<KindClassification> => {
        return deserialize_KindClassification_internal(value);
      })(value["discriminator"]);
    })();
    if (!parsed_discriminator.success) {
      return { success: false, reason: parsed_discriminator.reason };
    }
    if (!hasProp(value, "id")) {
      return { success: false, reason: `[#/components/schemas/TagKindClassification/id]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'id'.` };
    }
    const parsed_id = ((): ParserResult<bigint> => {
      return ((value: unknown): ParserResult<bigint> => {
        if (typeof value === "number") {
          return { success: true, value: BigInt(value) };
        }
        if (typeof value === "bigint") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/TagKindClassification/id]: '${value}' expected to be of type bigint or number.` };
      })(value["id"]);
    })();
    if (!parsed_id.success) {
      return { success: false, reason: parsed_id.reason };
    }
    if (!hasProp(value, "kind")) {
      return { success: false, reason: `[#/components/schemas/TagKindClassification/kind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
    }
    const parsed_kind = ((): ParserResult<KindClassification> => {
      return ((value: unknown): ParserResult<KindClassification> => {
        return deserialize_KindClassification_internal(value);
      })(value["kind"]);
    })();
    if (!parsed_kind.success) {
      return { success: false, reason: parsed_kind.reason };
    }
    return { success: true, value: { discriminator: parsed_discriminator.value, id: parsed_id.value, kind: parsed_kind.value } };
  })(value);
}
export function deserialize_TagKindClassification(str: string): ParserResult<TagKindClassification> {
  return deserialize_TagKindClassification_internal(parseJsonWithNumbersAsBigint(str));
}
